var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',{staticClass:"tip"},[_vm._v(" Open an issue if you have any question or advice using this tool. ")]),_c('github-button',{attrs:{"href":"https://github.com/xlfsummer/beat-saber-version-transformer","data-size":"large","data-show-count":"true","aria-label":"xlfsummer/beat-saber-version-transformer"}},[_vm._v("Star")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }